<template>
  <div class="album-detail">
    <b-loading :active="loading"></b-loading>
    <div v-if="!loading" class="container">
      <div class="columns is-centered">
        <div class="column is-half-tablet">
          <div class="level is-mobile">
            <div class="level-left">
              <div class="level-item">
                <router-link
                  v-if="previous"
                  :to="{
                    name: 'album-detail',
                    params: { slug: previous.slug }
                  }"
                  class="button is-light"
                >
                  <vue-fontawesome icon="arrow-left" class="m-r-xs" /> Previous
                </router-link>
                <a
                  v-else
                  :disabled="!previous"
                  class="has-text-grey-light m-r-xs"
                >
                  <vue-fontawesome icon="arrow-left" /> Previous
                </a>
              </div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <router-link
                  v-if="next"
                  :to="{
                    name: 'album-detail',
                    params: { slug: next.slug }
                  }"
                  class="button is-light"
                >
                  Next <vue-fontawesome icon="arrow-right" class="m-l-xs" />
                </router-link>
                <a v-else :disabled="!next" class="has-text-grey-light m-l-xs">
                  Next <vue-fontawesome icon="arrow-right" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-centered">
        <div class="column is-half-tablet">
          <div class="card">
            <div class="card-image">
              <div class="cover-wrapper">
                <div
                  class="cover"
                  :style="{ 'background-image': `url('${albumImage}')` }"
                ></div>
              </div>
            </div>
            <div class="card-content">
              <div class="media">
                <div class="media-content">
                  <p class="title is-4">{{ album.name }}</p>
                  <p class="subtitle is-6">{{ album.artist }}</p>
                </div>
              </div>
              <div class="media">
                <div class="media-content">
                  <div class="data-item">
                    <legend class="title is-6">Artwork author:</legend>
                    <p class="subtitle is-6">{{ album.artwork_author }}</p>
                  </div>
                  <div class="data-item">
                    <legend class="title is-6">Genre:</legend>
                    <p class="subtitle is-6">{{ album.genre }}</p>
                  </div>
                  <div class="data-item">
                    <legend class="title is-6">Label:</legend>
                    <p class="subtitle is-6">{{ album.label }}</p>
                  </div>
                </div>
              </div>
              <div class="content">
                <time :datetime="album.published">{{ album.published }}</time>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlbumDetail",

  data() {
    return {
      loading: true
    };
  },

  computed: {
    albums() {
      return this.$store.state.albums;
    },
    album() {
      return this.albums[this.albumIndex];
    },
    albumIndex() {
      return this.albums.findIndex(
        item => item.slug == this.$route.params.slug
      );
    },
    albumImage() {
      if (this.album) {
        return this.album.image;
      }
      return "";
    },
    next() {
      if (this.albumIndex + 1 < this.albums.length) {
        return this.albums[this.albumIndex + 1];
      }
      return null;
    },
    previous() {
      if (this.albumIndex - 1 >= 0) {
        return this.albums[this.albumIndex - 1];
      }
      return null;
    }
  },

  beforeMount() {
    if (!this.albums.length) {
      this.getAlbums();
    } else {
      this.loading = false;
    }
  },

  methods: {
    async getAlbums() {
      this.loading = true;
      await this.$store.dispatch("getAlbums");
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
$radius: 4px;

.album-detail {
  .card {
    border-radius: $radius;
  }

  .cover-wrapper {
    overflow: hidden;
    cursor: pointer;
  }

  .cover {
    width: 100%;
    height: 100%;
    min-height: 300px;
    min-width: 300px;
    background-color: #cccccc;
    height: 300px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-top-left-radius: $radius;
    border-top-right-radius: $radius;
    transition: all 0.5s;
  }

  .data-item {
    margin-top: 1em;
  }
}

.cover-wrapper:hover .cover,
.cover-wrapper:focus .cover {
  transform: scale(1.2);
}
</style>
